/* eslint-disable import/prefer-default-export */
export const WARRANTY_LINE_ITEM = 'warranty';
export const WARRANTY_IMAGE_URL = 'https://purple3.prod.acquia-sites.com/themes/custom/themekit/assets/images/svg/extend.svg';

export const ORDER_STATUS_IN_PROGRESS = 'In Progress';
export const ORDER_STATUS_SHIPPED = 'Shipped';
export const ORDER_STATUS_DELIVERED = 'Delivered';
export const ORDER_STATUS_COMPLETE = 'Complete';
export const ORDER_STATUS_PENDING = 'Pending';
export const ORDER_STATUS_AWAITING_FULFILLMENT = 'Awaiting Fulfillment';
export const ORDER_STATUS_RETURNED = 'Returned';
export const ORDER_STATUS_CANCELED = 'Cancelled';

export const ORDER_LINE_ITEM_STATUS_INITIAL = 'initial';
export const ORDER_LINE_ITEM_STATUS_AWAITING = 'awaiting';
export const ORDER_LINE_ITEM_STATUS_PROCESSING = 'processing';
export const ORDER_LINE_ITEM_STATUS_FULFILLED = 'fulfilled';

export const MILLISECONDS_DAY_CALCULATION = 86400 * 1000;
export const NUMBER_THIRTY = 30;

export const FREE_LABEL = 'Free';

export const VARIANT_ATTRIBUTE_TITLE = 'title';
